import { OrganizationMemberOverview } from "@/features/manage-organizations";
import { requireAdmin } from "@/lib/tanstack-router/requireAdmin";
import { createFileRoute } from "@tanstack/react-router";

type InviteParams = {
  invite?: boolean | undefined;
  email?: string | undefined;
};

export const Route = createFileRoute(
  "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/organization-management"
)({
  component: requireAdmin(OrganizationManagement),
  validateSearch: (search: Record<string, unknown>): InviteParams => ({
    invite: (search.invite as boolean) || undefined,
    email: (search.email as string) || undefined
  })
});

function OrganizationManagement() {
  return <OrganizationMemberOverview />;
}
